import React, { useContext, useState } from "react";
import { MainContext } from "../../../../context/Context";

const RightSide = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { Sections } = useContext(MainContext);

  const menuItems = Sections[0].topics;

  const handleActiveTitle = (e: any, index: number) => {
    setActiveIndex(index);
    e.preventDefault();

    const targetId = e.currentTarget.getAttribute("href").substring(1);
    const targetElement = document.getElementById(targetId);

    const headerHeight = 64;

    const targetPosition =
      targetElement.getBoundingClientRect().top +
      window.scrollY -
      headerHeight -
      30;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth", // انیمیشن نرم
    });
  };

  return (
    <div className="w-[20%] relative pb-10">
      <div className="flex flex-col pb-5 mr-5 border-b border-[#333] sticky top-24 right-0">
        <h2 className="font-semibold text-white mb-5">On this Page</h2>
        {menuItems.map((item: string, index: number) => (
          <a
            key={index}
            className={`text-text5 cursor-pointer py-2 ${
              activeIndex === index ? "text-white" : ""
            }`}
            href={`#${item}`}
            onClick={(e) => handleActiveTitle(e, index)}
          >
            {item}
          </a>
        ))}
      </div>
    </div>
  );
};

export default RightSide;
